<section class="row g-3">
  @for (product of products(); track product.id) {
    @if (product) {
      <div class="col-12 col-sm-6 col-md-4">
        @defer (when product) {
          <app-product-card-v2 
            [cardResume]="{ productDetails: product, settings: { isCrossSell: true }}"
            (outProductAdded)="removeProduct($event)">
          </app-product-card-v2>
        } @placeholder {
          <div class="placeholder-glow">
            <div class="placeholder col-12" style="height: 200px;"></div>
          </div>
        } @error {
          <div class="alert alert-warning">
            Unable to load product
          </div>
        }
      </div>
    }
  }
</section>

<footer class="d-flex justify-content-center mt-4">
  <button class="btn btn-outline-primary" type="button" (click)="close()">
    Close
  </button>
</footer>